import { useBooleanState } from "./useBooleanState"

export function useForcedUpdate() {
  const { value, toggle } = useBooleanState(false)
  return [value, toggle] as [boolean, () => void]
}
